import { render, staticRenderFns } from "./TablePaginatedSubscriptions.vue?vue&type=template&id=5b5dcab6&scoped=true"
import script from "./TablePaginatedSubscriptions.vue?vue&type=script&lang=js"
export * from "./TablePaginatedSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedSubscriptions.vue?vue&type=style&index=0&id=5b5dcab6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5dcab6",
  null
  
)

export default component.exports